import { GetRequest, PostRequest } from '../../../../helpers/lopay_api_helper'
import {
  GetMerchantcashAdvancesDTO,
  PayoutMechanism,
  RepaymentActivityResponseDto,
  UpdateCashAdvancePayoutMechanismDTO,
} from '../dtos/merchant-cash-advance.dto'

export const getMerchantCashAdvances = async (merchantId: string) => {
  return GetRequest<GetMerchantcashAdvancesDTO>(
    `/support/merchant/${merchantId}/cash-advances`,
  )
}

export function getRepaymentActivity({
  merchantId,
  pageSize,
}: {
  merchantId: string
  pageSize?: number
}) {
  return function ({
    pageParam,
  }: {
    pageParam?: string
  }): Promise<RepaymentActivityResponseDto> {
    return GetRequest(
      `/support/merchant/${merchantId}/cash-advances/repayments`,
      {
        params: {
          ...(pageParam && { nextOffsetId: pageParam }),
          ...(pageSize && { pageSize }),
        },
      },
    )
  }
}

export const updateCashAdvancePayoutMechanism = async (
  merchantId: string,
  body: UpdateCashAdvancePayoutMechanismDTO,
) => {
  return PostRequest<{ newPayoutMechanism: PayoutMechanism }>(
    `/support/merchant/${merchantId}/cash-advances/update-payout-mechanism`,
    body,
  )
}

export const triggerRemittance = async (merchantId: string) => {
  return PostRequest<{ success: boolean; message: string }>(
    `/support/merchant/${merchantId}/cash-advances/trigger-remittance`,
    {},
  )
}
